import { useRef, useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import useTitle from "../../hooks/useTitle";
// import PulseLoader from 'react-spinners/PulseLoader'
import { Callout } from "@tremor/react";
import LandingHeader from "../../components/LandingHeader";
import LandingFooter from "../../components/LandingFooter";
import { useForgot_passwordMutation } from "./authApiSlice";

//OSTALO JE DA KAD UNESEMO NEPOSTOJECI MAIL ZA RESET ONDA DA IZBACI DA NE POSTOJI TAJ KORISNIK SA TIM MEJLOM
const Reset = ({ closeModalResetEmail }) => {
  const userRef = useRef();
  const errRef = useRef();
  const [email, setEmail] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [loading, setLoading] = useState(false);

  //Data je za reponse
  const [forgotPassword, { isSuccess, isError, error, data }] =
    useForgot_passwordMutation();

  // const navigate = useNavigate();
  // const dispatch = useDispatch();

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsg("");
  }, [email]);

  useEffect(() => {
    if (isSuccess) {
      // console.log("Success response:", data);

      // data objekat je dobar response message
      const successMessage = data?.message || "Uspesno poslato";
      alert(successMessage);
      window.location.reload();
    }

    if (isError) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      const errorMessage = error?.data?.message || "Nepostojeci korisnik";
      alert(errorMessage);
    }
  }, [isSuccess, isError, error, data]);

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (!email) {
      alert("Molimo Vas da popunite polje.");
      return;
    }

    try {
      // Trigger the forgot password mutation
      await forgotPassword({ email });
      setLoading(false);
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  const onEmailChanged = (e) => setEmail(e.target.value);

  const errClass = errMsg ? "errmsg" : "offscreen";

  // if (isLoading) return <PulseLoader color={"#FFF"} />

  const tailwindLogin_ = (
    <div className="flex items-center justify-center min-h-screen">
      <div className="md:w-full">
        <div className="sm:mx-auto sm:w-full sm:max-w-md"></div>

        <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-[480px] border-4 border-[#66BB6A] rounded-3xl p-4 bg-white">
          <div
            className="bg-white px-3 py-6 shadow rounded-3xl sm:px-6 border-4 border-[#DCC72A]"
            // onClick={handleModalClick}
          >
            <Callout
              ref={errRef}
              className={errClass}
              color="red"
              style={{ display: "none" }}
            >
              {errMsg}
            </Callout>
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div className="relative">
                <button
                  onClick={closeModalResetEmail}
                  className="absolute top-0 right-0 text-black hover:text-gray-700 text-sm"
                  aria-label="Close"
                >
                  ✘
                </button>
              </div>
              <h2
                className="mt-1 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900"
                style={{ marginTop: "0px" }}
              >
                Unesite mail
              </h2>
              <div>
                <label
                  htmlFor="text"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Email
                </label>
                <div className="mt-2">
                  <input
                    type="text"
                    id="username"
                    ref={userRef}
                    value={email}
                    onChange={onEmailChanged}
                    autoComplete="off"
                    disabled={loading}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm sm:leading-6"
                    required
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded bg-green-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                >
                  {loading ? "Šalje se..." : "Pošalji"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );

  //Stari izgled ali radi
  const tailwindLogin = (
    <div className="flex min-h-full flex-1 flex-col justify-center py-10 sm:px-6 lg:px-8 h-screen">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Unesite Vaš email
        </h2>
        {/* Ovde postavi tremor callout crveni */}
        <Callout
          ref={errRef}
          className={errClass}
          color="red"
          style={{ display: "none" }}
        >
          {errMsg}
        </Callout>
        {/* <p ref={errRef} className={errClass} aria-live="assertive">{errMsg}</p> */}
      </div>

      <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-[480px] border border-black-500 rounded-md">
        <div className="bg-white px-3 py-6 shadow sm:rounded sm:px-6">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="text"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Email
              </label>
              <div className="mt-2">
                <input
                  type="text"
                  id="username"
                  ref={userRef}
                  value={email}
                  onChange={onEmailChanged}
                  autoComplete="off"
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm sm:leading-6"
                  required
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded bg-green-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
              >
                Posalji
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* <LandingHeader /> */}
      {tailwindLogin_}
      {/* <LandingFooter /> */}
    </>
  );
};
export default Reset;
